import { PaymentRetryError, PaymentRetryErrorKind } from "@types-runway/paymentRetry";

interface FailureShape {
  response?: { status?: number; data?: { message?: unknown; declineCode?: unknown } };
}

const readNonEmptyText = (value: unknown): string | undefined =>
  typeof value === "string" && value.trim() !== "" ? value : undefined;

export const classifyPaymentRetryError = (failure: unknown): PaymentRetryError => {
  const { response } = (failure ?? {}) as FailureShape;

  if (!response) {
    return { kind: PaymentRetryErrorKind.NETWORK_UNAVAILABLE, isRetryable: true };
  }

  if (response.status === 401) {
    return { kind: PaymentRetryErrorKind.SESSION_ENDED, isRetryable: false };
  }

  const reason = readNonEmptyText(response.data?.message);
  const declineCode = readNonEmptyText(response.data?.declineCode);
  const kind =
    response.status === 402 ? PaymentRetryErrorKind.PAYMENT_REFUSED : PaymentRetryErrorKind.UNKNOWN;

  return {
    kind,
    ...(reason && { reason }),
    ...(declineCode && { declineCode }),
    isRetryable: true,
  };
};
